export default {
  service: "Service",
  services: "Services",
  name: "Name",
  description: "Description",
  rate: "Rate",
  hourlyRate: "Hourly Rate",
  isBillable: "Billable",
  is_billable: "Billable",
  is_archived: "Status",
  billable: "Billable",
  notBillable: "Not billable",
  active: "Active",
  archived: "Archived",
  created_at: "Created",
  createService: "Create Service",
  editService: "Edit Service",
  updateService: "Save Changes",
  archiveService: "Archive",
  unarchiveService: "Unarchive",
  deleteService: "Delete",
  confirmDeleteTitle: "Delete Service",
  confirmDeleteTitle_plural: "Delete Services",
  confirmDeleteMessage: "Are you sure you want to delete this service?",
  confirmDeleteMessage_plural:
    "Are you sure you want to delete these {{count}} services?",
  deleteCannotDelete:
    "This service cannot be deleted because it has time entries associated with it.",
  serviceCreated: "Service created successfully",
  serviceUpdated: "Service updated successfully",
  serviceArchived: "Service archived successfully",
  serviceUnarchived: "Service unarchived successfully",
  servicesDeleted: "Services deleted successfully",
  memberRateOverrides: "Member Rate Overrides",
  memberRateOverridesDescription:
    "Set custom rates for specific members when they perform this service. These rates override the service's hourly rate and the member's base rate. This does not restrict which members can use this service.",
  memberRateOverridesDescriptionShort:
    "Select members to set custom rates for this service.",
  members: "Members",
  hasRateOverrides: "Has Rate Overrides",
  rateOverridesCount: "{{count}} rate override(s)",
  memberRatePlaceholderService: "Service rate: {{rate}}/hr",
  memberRatePlaceholderBase: "Base rate: {{rate}}/hr",
  backToList: "Back to Services",
};
